import React from 'react';
import Authentication from "./Auth/Authentication";
import { BrowserRouter as Router } from "react-router-dom";
import Pusher from "./Pusher";
import Routes from "./Routes/index";
import Helmet from "react-helmet";
import { ToastContainer } from 'react-toastify';

export default function App() {

    return (
        <Authentication>
            <Pusher>
                <Router>
                    <Helmet
                        defaultTitle="ZAS"
                        titleTemplate="ZAS - %s"
                    />
                    <Routes></Routes>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnHover
                    />
                </Router>
            </Pusher>
        </Authentication>
    );
}
